module.exports = __webpack_public_path__ + "img/1513777153.fb9f15a6.jpg";